<div class="box-form-ui container">
  <h2 class="pep-question">Cuéntanos</h2>

  <form id="FormPEP" class="form-pep" [formGroup]="pepForm" autocomplete="off" (ngSubmit)="onSubmit()">
    <p>
      ¿Eres una persona políticamente expuesta?
      <span (click)="openPepDialog()" (keydown)="openPepDialog()" class="open-dialog-button">¿Qué es?</span>
    </p>
    <mat-radio-group class="box-pep-radio" formControlName="firstPepInput">
      <mat-radio-button value="false">{{ NEGATIVE_TEXT }}</mat-radio-button>
      <mat-radio-button value="true">{{ AFFIRMATIVE_TEXT }}</mat-radio-button>
    </mat-radio-group>
    <p class="second-question">
      ¿Eres residente, y/o declaras o pagas impuestos en otro país?
      <span (click)="openFiscalDialog()" (keydown)="openFiscalDialog()" class="open-dialog-button">¿Qué es?</span>
    </p>
    <mat-radio-group class="box-pep-radio" formControlName="secondPepInput">
      <mat-radio-button value="false">{{ NEGATIVE_TEXT }}</mat-radio-button>
      <mat-radio-button value="true">{{ AFFIRMATIVE_TEXT }}</mat-radio-button>
    </mat-radio-group>

    <div class="box-btn-submit">
      <button class="btn btn-degraded blue" type="submit" [disabled]="!pepForm.valid" id="SubmitFormPEP">
        {{ BUTTON_SUBMIT_TEXT }}
      </button>
    </div>
  </form>
</div>